<template>
    <div ref="dataLeak" v-if="viewData.isInitializationDone">
        <div class="row" v-if="viewData.currentPage === viewData.pages.SELECT_MODE">
            <div class="column" align="center">
                <h5>
                    Was möchten Sie prüfen?
                </h5>
            </div>
            <div class="small-4 column">
                <button class="button success expand" @click.stop="setMode(modes.EMAIL)">E-Mail Adresse</button>
            </div>
            <div class="small-4 column">
                <button class="button success expand" @click.stop="setMode(modes.PHONE)">Telefonnummer</button>
            </div>
            <div class="small-4 column">
                <button class="button success expand" @click.stop="setMode(modes.BOTH)">Beides</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.DATA_LEAK_FORM">
            <div class="column">
                <DataLeaksForm
                    ref="dataLeaksForm"
                    :mode="viewData.mode"
                    :disabled="viewData.isLoading"
                    @changeFormData="onChangeFormData"
                    @updateValidity="onUpdateValidity"
                    @submitForm="onFormSubmit"
                />
                <PrivacyHint />
            </div>
            <div class="column small-12" v-if="viewData.isLoading">
                <LoadingSpinner/>
            </div>
            <template v-else>
                <div class="column small-6" v-if="showChangeModeButton">
                    <button :disabled="viewData.isLoading" class="button success expand" @click.stop="changeMode">{{ changeModeButtonLabel }}</button>
                </div>
                <div class="column" v-if="showValidateButton" :class="{ 'small-6': showChangeModeButton }">
                    <button class="button warning expand" @click.stop="validateForm">Eingabe prüfen</button>
                </div>
                <div class="column" v-else :class="{ 'small-6': showChangeModeButton }">
                    <button :disabled="viewData.isLoading" class="button success expand" @click.stop="checkPwned">Jetzt prüfen</button>
                </div>
            </template>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.NOT_PWNED_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="ratisColoredText">
                        Gute Nachrichten
                    </h4>
                    <p>
                        {{notPwnedText}}
                    </p>
                    <p v-if="showNotPwnedAdditionalText">
                        Haben Sie Ihre {{ notPwnedAdditionalText }} bereits geprüft? Falls nicht, starten Sie die Eingabe neu und wählen Sie "{{ notPwnedAdditionalText }}" aus.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Neue Eingabe starten</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.PWNED_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="orange-colored-text">
                        ACHTUNG
                    </h4>
                    <p>
                        {{ pwnedText }}
                    </p>
                    <p>
                        Nachfolgend finden Sie die Datenlecks, bei denen wir eine Betroffenheit identifizieren konnten:
                    </p>
                    <DataLeaksInfo :data-leaks="dataLeaks" :mode="viewData.mode"/>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Neue Eingabe starten</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.ERROR_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Es ist ein Fehler aufgetreten
                    </h4>
                    <p>
                        Wir bitten Sie um Entschuldigung.
                        {{ errorDescription }}
                        Sollten Sie auch nach einem neuerlichen Versuch immer noch Probleme haben, wenden Sie sich bitte an
                        <a href="mailto:info@ratis.de">info@ratis.de</a>.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Erneut versuchen</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.APP_DOWN">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Anwendung nicht verfügbar
                    </h4>
                    <p>
                        Die Anwendung steht aktuell leider nicht zur Verfügung. Bitte versuchen Sie es später erneut.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DataLeaksForm from '../components/DataLeaksForm';
import DataLeak from '../api/dataLeak';
import Config from '../constants/Config';
import PrivacyHint from '../components/PrivacyHint';
import Modes from '../constants/Modes';
import Maintenance from '../api/maintenance';
import TypeHelper from '../helper/TypeHelper';
import modes from '../constants/Modes';
import DataLeaksInfo from '../components/DataLeaksInfo.vue';
import LoadingSpinner from '../components/LoadingSpinner.vue';

export default {
    name: 'FormView',
    components: {LoadingSpinner, DataLeaksInfo, DataLeaksForm, PrivacyHint},
    data: () => ({
        viewData: {
            currentPage: 0,
            pages: {
                SELECT_MODE:        0,
                DATA_LEAK_FORM:     1,
                PWNED_PAGE:         2,
                ERROR_PAGE:         3,
                NOT_PWNED_PAGE:     4,
                APP_DOWN:           5
            },
            isFormValid: false,
            isLoading: false,
            isTooManyRequestsError: false,
            mode: null,
            isInitializationDone: false
        },
        formData: {
            pwned_account: null,
            fb_profile_link: null
        },
        constants: {
            TOO_MANY_REQUESTS_STATUS_CODE: 429
        },
        modes: Modes,
        dataLeaks: [
        ]
    }),
    computed: {
        showValidateButton()
        {
            return this.viewData.isFormValid === false;
        },
        errorDescription()
        {
            if (this.viewData.isTooManyRequestsError)
                return 'Leider ist beim Prüfen der ' + this.pwnedAccountTypeString + ' ein Fehler aufgetreten, da die maximale Anzahl an Anfragen erreicht wurde. Bitte versuchen Sie es in einer Minute erneut.';

            return 'Leider ist beim Prüfen der ' + this.pwnedAccountTypeString + ' ein Fehler aufgetreten. Bitte versuchen Sie es erneut.';
        },
        isOnlyPhoneNumber()
        {
            return this.viewData.mode === Modes.PHONE;
        },
        isOnlyEmail()
        {
            return this.viewData.mode === Modes.EMAIL;
        },
        pwnedAccountTypeString()
        {
            let phoneText = 'Telefonnummer';
            let emailText = 'E-Mail Adresse';
            if (this.isOnlyPhoneNumber)
                return phoneText;
            else if (this.isOnlyEmail)
                return emailText;

            return phoneText + ' und ' + emailText;
        },
        changeModeButtonLabel()
        {
            if (this.isOnlyPhoneNumber)
                return 'Zu E-Mail Adresse wechseln';
            else
                return 'Zu Telefonnummer wechseln';
        },
        showChangeModeButton()
        {
            return TypeHelper.isNotNullOrUndefined(this.viewData.mode) && this.viewData.mode !== modes.BOTH;
        },
        notPwnedAdditionalText()
        {
            if (this.isOnlyPhoneNumber)
                return 'E-Mail Adresse';
            else
                return 'Telefonnummer';
        },
        showNotPwnedAdditionalText()
        {
            return this.isOnlyEmail || this.isOnlyPhoneNumber;
        },
        notPwnedText()
        {
            if (this.isOnlyEmail || this.isOnlyPhoneNumber)
                return 'Die angegebene ' + this.pwnedAccountTypeString + ' ist von keinem der von uns geprüften Datenlecks betroffen.';

            return 'Die angegebene ' + this.pwnedAccountTypeString + ' sind von keinem der von uns geprüften Datenlecks betroffen.';
        },
        pwnedText()
        {
            if (this.isOnlyEmail || this.isOnlyPhoneNumber)
                return 'Die angegebene ' + this.pwnedAccountTypeString + ' ist leider von mindestens einem der von uns geprüften Datenlecks betroffen.';

            return 'Die angegebene ' + this.pwnedAccountTypeString + ' sind leider von mindestens einem der von uns geprüften Datenlecks betroffen.';
        }
    },
    methods: {
        validateForm()
        {
            this.$refs.dataLeaksForm.validateForm();
        },
        async checkPwned()
        {
            this.viewData.isLoading = true;
            try
            {
                let requestData = {
                    phone: this.formData.phone,
                    mail: this.formData.mail
                };

                let response = await DataLeak.check(requestData);

                if (response.pwned)
                {
                    this.dataLeaks = response.data_leaks;
                    this.viewData.currentPage = this.viewData.pages.PWNED_PAGE;
                }
                else
                    this.viewData.currentPage = this.viewData.pages.NOT_PWNED_PAGE;

                this.createTrackingIframe();
            }
            catch (error)
            {
                if (TypeHelper.isNotNullOrUndefined(error.response)
                    && error.response.status === this.constants.TOO_MANY_REQUESTS_STATUS_CODE)
                    this.viewData.isTooManyRequestsError = true;

                this.viewData.currentPage = this.viewData.pages.ERROR_PAGE;
            }
            finally
            {
                this.viewData.isLoading = false;
                this.$refs.dataLeak.scrollIntoView(true);
            }
        },
        onChangeFormData(newFormData)
        {
            let me = this;
            Object.keys(newFormData).forEach(property => {
                me.formData[property] = newFormData[property];
            });
        },
        onUpdateValidity(newValidity)
        {
            this.viewData.isFormValid = newValidity;
        },
        onFormSubmit()
        {
            if (this.viewData.isFormValid)
                this.checkPwned();
            else
                this.validateForm();
        },
        async resetForm()
        {
            await this.checkHealth();

            if (this.viewData.currentPage !== this.viewData.pages.APP_DOWN)
            {
                this.viewData.currentPage = this.viewData.pages.SELECT_MODE;
                this.formData = {
                    phone: null,
                    mail: null
                };

                this.viewData.isFormValid = false;
                this.viewData.isTooManyRequestsError = false;
                this.viewData.mode = null;
                this.dataLeaks = [];
            }
            this.$refs.dataLeak.scrollIntoView(true);
        },
        setMode(mode)
        {
            this.viewData.mode = mode;

            if (this.viewData.currentPage === this.viewData.pages.SELECT_MODE)
                this.viewData.currentPage = this.viewData.pages.DATA_LEAK_FORM;
        },
        changeMode()
        {
            if (this.viewData.mode === Modes.PHONE)
                this.setMode(Modes.EMAIL);
            else
                this.setMode(Modes.PHONE);
        },
        createTrackingIframe()
        {
            let iframe = document.createElement('iframe');
            iframe.setAttribute('id', 'trackingIframe');
            iframe.setAttribute('src', Config.TRACKING_URL);
            iframe.style.display = "none";
            document.body.appendChild(iframe);
            let me = this;
            iframe.onload = () => me.removeTrackingIframe();
        },
        removeTrackingIframe()
        {
            let iframe = document.getElementById('trackingIframe');
            document.body.removeChild(iframe);
        },
        async checkHealth()
        {
            try
            {
                let response = await Maintenance.checkHealth();

                if (response.is_down)
                    this.viewData.currentPage = this.viewData.pages.APP_DOWN;
            }
            catch (error)
            {
                this.viewData.currentPage = this.viewData.pages.APP_DOWN;
            }
        }
    },
    async mounted()
    {
        await this.checkHealth();
        this.viewData.isInitializationDone = true;
    }
};
</script>

<style scoped>
    .ratisColoredText{
        color:#e10065;
    }
    .redColoredText{
        color: red;
    }
    .bold-text {
        font-weight: bold;
    }
    .orange-colored-text {
        color: orange;
    }
</style>
